import { spawn } from "node:child_process";

/**
 * Best effort: on a headless box or over SSH there is no browser to open, so a
 * failure here is not an error — the URL is always printed as well.
 */
export function openBrowser(url: string): void {
  const command =
    process.platform === "darwin"
      ? "open"
      : process.platform === "win32"
        ? "cmd"
        : "xdg-open";
  const commandArgs =
    process.platform === "win32" ? ["/c", "start", "", url] : [url];

  try {
    const child = spawn(command, commandArgs, {
      stdio: "ignore",
      detached: true,
    });
    // A missing `xdg-open` (minimal containers, most SSH hosts) surfaces as an
    // ASYNCHRONOUS 'error' event that the try/catch cannot see. Unhandled, it
    // is an uncaught exception that kills the process mid-login — so the CLI
    // would stop polling instead of falling back to the printed URL.
    child.on("error", () => {});
    child.unref();
  } catch {
    // Printing the URL is the fallback, and it already happened.
  }
}
